var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-content-loading',{attrs:{"width":300,"height":380}},[_c('rect',{attrs:{"x":"0","y":"0","width":"300","height":"250"}}),_c('rect',{attrs:{"x":"75","y":"260","width":"150","height":"30"}}),_c('rect',{attrs:{"x":"0","y":"300","width":"300","height":"30"}}),_c('rect',{attrs:{"x":"0","y":"340","width":"300","height":"30"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }